import { DateTime } from 'luxon';

const oneMinute = 60000;

export const convertTimeToDisplayString = (uctDateTimeISO, timeZone): string => {
  const utcDate = DateTime.fromISO(uctDateTimeISO, { zone: 'utc' });
  const updatedTime = utcDate.setZone(timeZone);
  return updatedTime.toFormat('M/d/yyyy, h:mm a');
};

export const convertToUTC = (date, timeZone) => {
  if (!date || !timeZone) return null;

  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  const formattedDate = date.toLocaleString('en-US', {
    month: 'numeric', // M
    day: 'numeric', // ds
    year: 'numeric', // yyyy
    hour: 'numeric', // h
    minute: '2-digit', // mm
    hour12: true, // a for AM/PM
  });

  try {
    const inputDate = DateTime.fromFormat(formattedDate, 'M/d/yyyy, h:mm a', {
      zone: timeZone,
    });
    const utcDate = inputDate.toUTC();
    return utcDate.toISO();
  } catch (e) {
    console.error(`registration::convertToUTC(): ${e}`);
  }
};

export const getUnsignedHoursOffset = (strOffset) =>
  Math.sqrt(Math.pow(strOffset, 2)) / 60;

export const getDSTOffsetHours = (date: Date, offsetHours: number) => {
  if (isDST(date)) {
    return offsetHours - 1;
  }

  return offsetHours;
};

export const isDST = (date: Date) => {
  try {
    const jan = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
    const jul = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();

    return Math.max(jan, jul) > date.getTimezoneOffset();
  } catch (e) {
    console.error(`registration::isDST(): ${e}`);
  }
};

export const getOrgTimezoneOffset = (orgTimezoneIana) => {
  try {
    const orgDatetime = DateTime.fromObject({
      zone: orgTimezoneIana || 'Europe/London',
    });

    return getUnsignedHoursOffset(orgDatetime.offset);
  } catch (e) {
    console.error(`registration::getOrgTimezoneOffset(): ${e}`);
  }
};

export const getOrgTimezone = (orgTimezoneIana, orgTimezone) => {
  try {
    if (orgTimezoneIana?.length > 0) {
      const abbreviatedTimezone = new Date()
        .toLocaleTimeString('en-us', {
          timeZone: orgTimezoneIana,
          timeZoneName: 'short',
        })
        .split(' ')[2];

      return abbreviatedTimezone || orgTimezone;
    }
  } catch (e) {
    console.error(`registration:getOrgTimezone() -- ${e}`);
  }
};

export const excludeDaysUntilStartDate = (date: Date) =>
  new Date(date?.getTime() + oneMinute);

export const excludeCurrentDayPastTimes = (datetime: Date) => {
  try {
    const currentDatetime = new Date();
    const selectedDatetime = new Date(datetime);

    return currentDatetime.getTime() < selectedDatetime.getTime();
  } catch (e) {
    console.error(`registration::excludeCurrentDayPastTimes(): ${e}`);
  }
};

export const excludeStartDatePastTimes = (datetime: Date, startDate: Date) => {
  try {
    const startDatetime = new Date(startDate);
    const selectedDatetime = new Date(datetime);

    return startDatetime.getTime() < selectedDatetime.getTime();
  } catch (e) {
    console.error(`registration::excludeStartDatePastTimes(): ${e}`);
  }
};
